(function() {
  var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
templates['vanityURLForm.tmpl'] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "<input type=\"hidden\" name=\"challengeId\" value=\"";
  if (stack1 = helpers.challengeId) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.challengeId); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "\" />";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "";
  buffer += "\n    	<li>www.donorschoose.org/"
    + escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0))
    + "</li>\n    	";
  return buffer;
  }

  buffer += "<form class=\"form-redux js-vanity-url-form\" id=\"vanity-url-form\" name=\"vanityForm\" method=\"post\" action=\"";
  if (stack1 = helpers.secureBaseURL) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.secureBaseURL); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "common/vanity-url.html\">\n<input type=\"hidden\" name=\"callback\" value=\"vanityURLCallback\" />\n<input type=\"hidden\" name=\"postMessage\" value=\"parent.postMessage\" />\n<input type=\"hidden\" name=\"vanityType\" value=\"";
  if (stack1 = helpers.vanityType) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.vanityType); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "\" />\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.challengeId), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<strong>Personalize your web address to make it even easier to share!</strong>\n<div class=\"examples\">\n	Examples:\n	<ul id=\"vanity-url-examples\">\n    	";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.examples), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </ul>\n</div>\n<div id=\"personalizeURL\">\n	<p>You can only set this once so choose carefully. Use only lowercase letters, numbers, and hyphens.</p>\n	donorschoose.org/<input type=\"text\" name=\"vanityURL\" id=\"vanityURL\" value=\"\" />\n	<a id=\"check-availability-link\" class=\"js-check-availability-link\">Check availability</a>\n	<div class=\"error-text\"></div>\n	<div><a class=\"button-primary small js-submit-vanity-form-button\" id=\"submitVanityFormButton\">Save web address</a></div>\n</div>\n</form>\n";
  return buffer;
  });
})();